class HowToVideos {
  constructor() {
    // State
    this.activeCategory = "all";
    this.defaultPathname = "/pages/how-to-videos";

    // Category Elements
    this.categoryContainer = document.querySelector(
      ".how-to-videos-categories"
    );

    // Find the container for video categories
    this.categories = Array.from(
      this.categoryContainer.querySelectorAll(".how-to-videos-category")
    );

    // Videos Elements
    this.videoGrid = document.querySelector(".how-to-videos-grid");

    // Get all video elements
    this.videos = Array.from(
      this.videoGrid.querySelectorAll(".how-to-video-block")
    );

    // Event Listener
    this.categoryContainer.addEventListener(
      "click",
      this.handleCategoryClick.bind(this)
    );

    // Load category and filter videos
    this.loadCategoryFromURL();
  }

  /**
   * ### Event handler for category clicks
   * @param {Event} event - Click event
   */
  handleCategoryClick(event) {
    // Get element clicked
    const categoryEl = event.target.closest(".how-to-videos-category");

    // Guard clause, in case element doesn't exist
    if (!categoryEl) return;

    // Get data from the element
    const category = categoryEl.dataset.category;
    const isActive = categoryEl.dataset.activeVideoCategory === "true";

    if (!isActive) {
      // Call category controller
      this.categoryController(category);

      // Call filter controller
      this.filterVideos(category);

      // Call URL controller
      this.loadCategoryFromURL();
    }
  }

  /**
   * ### Filter videos based on the selected category
   * @param {String} category Category
   * @returns
   */
  filterVideos(category = "") {
    // Guard clause, in case category is empty
    if (!category) return;

    // Show all videos
    if (category === "all") {
      this.showAllVideos();
      return;
    }

    // Reset all videos state to false
    this.resetVideosState();

    // Search elements and change state
    this.videos.forEach((el) => {
      if (el.dataset.category === category) {
        el.dataset.activeVideo = true;
      }
    });
  }

  /**
   * ### Controller for handling category selection
   * @param {String} category Category
   * @returns
   */
  categoryController(category = "") {
    // Guard clause, if category is empty
    if (!category) return;

    // Reset all categories state to false
    this.resetCategoriesState();

    // Set active filter
    this.activeCategory = category;

    // Get element with category
    const categoryEl = this.categoryContainer.querySelector(
      `.how-to-videos-category[data-category="${category}"]`
    );

    // Set to active
    categoryEl.dataset.activeVideoCategory = true;

    // Update URL pathname with new category
    this.updateURLCategory(category);
  }

  /**
   * ### Load category from the URL and update the page accordingly
   */
  loadCategoryFromURL() {
    // Get pathname and href
    const { pathname } = window.location;

    // Get filter from the pathname
    const category = this.getCategoryFromURL(pathname);

    // Guard clause, if no category found
    if (!category) return;

    // Call category controller
    this.categoryController(category);

    // Call video filter
    this.filterVideos(category);
  }

  /**
   * ### Extract the category from the URL pathname
   * @param {String} pathname Current window pathname
   * @returns Clean filter param from the URL
   */
  getCategoryFromURL(pathname = "") {
    // Guard clause, if pathname is empty
    if (!pathname) return "";

    // Remove default pathname
    let removedDefaultPathname = pathname
      .replace(this.defaultPathname, "")
      .replace("/", "");

    // Guard clause, if no category found
    if (!removedDefaultPathname) return "";

    return removedDefaultPathname;
  }

  /**
   * ### Update the URL with the selected category
   * @param {String} category Category
   */
  updateURLCategory(category = "") {
    // Guard clause, if category is empty
    if (!category) return;

    // Build new path
    const newPath = `${this.defaultPathname}/${category}`;

    // Update URL
    history.pushState(null, null, newPath);
  }

  /**
   * ### Show all videos by setting their state to active
   */
  showAllVideos() {
    this.videos.forEach((el) => (el.dataset.activeVideo = true));
  }

  /**
   * ### Reset the state of all category elements to inactive
   */
  resetCategoriesState() {
    this.categories.forEach((el) => (el.dataset.activeVideoCategory = false));
  }

  /**
   * ### Reset the state of all video elements to inactive
   */
  resetVideosState() {
    this.videos.forEach((el) => (el.dataset.activeVideo = false));
  }
}

const howToVideos = new HowToVideos();
